/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { createSelector } from '@ngrx/store';
import { selectCommentingState } from './feature-selectors';
import { CommentModel } from '../../models';

export const selectCommentEntities = createSelector(
  selectCommentingState,
  (state) => state.commentEntityState.entities,
);

const selectAll = createSelector(selectCommentEntities, (entities) =>
  Object.values(entities).sort((comment1, comment2) => new Date(comment1.createdAt).getTime() - new Date(comment2.createdAt).getTime()),
);

const createSelectorById = (commentId: string) =>
  createSelector(selectCommentEntities, (entities) => entities[commentId]);

const isMatchingRealComment = (optimistic: CommentModel, real: CommentModel): boolean => {
  if (real.body !== optimistic.body) {
    return false;
  }
  const optimisticTime = new Date(optimistic.createdAt).getTime();
  const realTime = new Date(real.createdAt).getTime();
  return Math.abs(optimisticTime - realTime) <= 1000;
};

const createSelectorByThreadId = (threadId: string) =>
  createSelector(selectAll, (comments) => {
    const threadComments = comments.filter((comment) => comment.threadId === threadId);
    const realComments = threadComments.filter((comment) => !comment.isCreationInProgress);

    // Filter out optimistic comments if a real one with same body and createdAt within 1 seconds exists
    const filtered = threadComments.filter((comment) => {
      if (!comment.isCreationInProgress) {
        return true;
      }
      return !realComments.some((real) => isMatchingRealComment(comment, real));
    });
    return filtered;
  });

export const CommentSelectors = {
  selectAll,
  createSelectorById,
  createSelectorByThreadId,
};
